import React from "react"

function ChainLink({ width = 24, height = 24, fill = "none", ...props }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="6 6 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M19.1762 19.7872C16.7882 20.0553 15.4901 18.7267 15.1043 16.9755C14.8043 15.577 15.0982 14.1148 15.9248 12.9471C16.9167 11.6031 18.0189 10.4367 19.2435 9.44535C20.9212 8.11849 23.2051 7.85214 25.1461 8.75896C25.3971 8.82264 25.6175 8.94204 25.8319 9.07368C27.1483 9.89784 28.0239 11.2792 28.2015 12.8259C28.379 14.3726 27.8402 15.9156 26.7381 17.0171C25.5625 18.2142 24.1848 19.5931 24.1848 19.5931"
        stroke="#003E4C"
        strokeWidth="1.00146"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.9164 15.9349C21.445 16.7564 21.8454 18.3213 21.4682 20.3593C21.3119 21.2828 20.9314 22.1534 20.3551 22.8935C19.295 24.2404 18.1101 25.3831 16.8059 26.3359C15.0644 27.5778 12.7701 27.7304 10.8765 26.7283C10.629 26.6522 10.4147 26.522 10.2072 26.3799C8.93337 25.4914 8.12738 24.0682 8.02685 22.5146C7.9264 20.961 8.54119 19.4467 9.69667 18.4013C10.9303 17.2641 12.3748 15.9553 12.3748 15.9553"
        stroke="#003E4C"
        strokeWidth="1.00146"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default ChainLink
